import React from 'react'
import { useGlobalState } from 'utils/hooks/globalStateProvider'
import { STATUS_SUCCESS, STATUS_ERROR } from 'utils/constants.js'
import { iconCheck } from 'utils/icons'

const TIMING_MS = 8000

function Message() {
  const [state, dispatch] = useGlobalState()
  const { isOpen, status, text } = state.message

  if (!isOpen) return <></>

  const timeout = setTimeout(() => closeMessage(), TIMING_MS)

  const closeMessage = () => {
    dispatch({
      message: {
        isOpen: false,
      },
    })
    clearTimeout(timeout)
  }

  return (
    <div
      role="button"
      tabIndex="0"
      className={`f f-align-items-center message ${
        status === STATUS_SUCCESS ? 'message--success' : status === STATUS_ERROR ? 'message--error' : ''
      }`}
      onClick={closeMessage}
      onKeyDown={closeMessage}
    >
      {status === STATUS_SUCCESS && iconCheck}
      <span className="ft-primary">{text}</span>
    </div>
  )
}

export default Message
